import { svg } from 'lit-element';

export const inputClear = svg`<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 8C0 12.418 3.58 16 8 16C12.42 16 16 12.418 16 8C16 3.582 12.42 0 8 0C3.58 0 0 3.582 0 8ZM5.5 12L8 9.5L10.5 12L12 10.5L9.5 8L12 5.5L10.5 4L8 6.5L5.5 4L4 5.5L6.5 8L4 10.5L5.5 12Z" fill="#D2D4D8"/></svg>`;
